import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { signOut } from '../../utils/signOut';

// Shown instead of the pages when Auth0 refuses the sign-in, for example an
// account without an Investigate role (scalens-architecture
// auth/terraform/actions/add-scalens-claims.js). The pages would otherwise send
// the person straight back to Auth0, which refuses again, in a loop.
function AuthError({ error }) {
  const { logout } = useAuth0();
  const noAccess = error?.error === 'access_denied';

  useEffect(() => {
    // Drop ?error=…&state=… so a reload signs in again instead of failing on a used state.
    window.history.replaceState({}, document.title, window.location.pathname);
  }, []);

  return (
    <div className="w-full h-[100vh] flex justify-center items-center px-4">
      <div className="bg-backgroundCard max-w-md px-8 py-6 rounded-2xl text-title_bodyFonts shadow-md text-center">
        <h1 className="text-xl font-bold mb-3">
          {noAccess ? 'No access to Investigate' : 'Sign-in failed'}
        </h1>
        <p className="mb-5">{error?.message || 'Something went wrong while signing you in.'}</p>
        <button
          className="bg-backgroundCard px-6 py-2 rounded-2xl text-title_bodyFonts shadow-md cursor-pointer"
          onClick={() => signOut(logout)}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

export default AuthError;
